import React from "react";
import "../styles/BlogStyles/BlogStyles.css";
import bloglist from "../assets/blog1.jpeg";


const BlogPostDetail = () => {
  return (
    <article className="blog-detail-section py-5 bg-light">
      <div className="container bg-white p-0 rounded shadow-sm overflow-hidden content-container">
        
        {/* --- 1. Top Image Section (Requested) --- */}
        <div className="w-100">
          <img
            src={bloglist} 
            alt="Madhi Academy Classroom"
            className="img-fluid w-100 object-fit-cover"
            style={{ height: "450px" }} 
          />
        </div>

        <div className="p-4 p-lg-5">
          {/* --- 2. Main Title --- */}
          <div className="text-center mb-4">
            <h1 className="fw-bold text-purple display-6 mb-3">
              Best School Tuitions in Chennai | CBSE & State Board – Madhi Academy
            </h1>
          </div>

          {/* --- 3. Introduction --- */}
          <div className="blog-content text-secondary">
            <p className="mb-4 lead fs-6">
              Every child deserves the right guidance to excel in school. At <strong>Madhi Academy, Chennai</strong>, 
              we provide academic support from 1st to 12th standard for both <strong>State Board</strong> and <strong>CBSE students</strong>. 
              Our goal is simple – to make learning easy, engaging, and result-oriented.
            </p>
            <p className="mb-5">
              With experienced teachers, small batch sizes, and individual attention, we ensure that every student builds a strong foundation for a bright future.
            </p>

            {/* --- 4. Why Choose Us --- */}
            <h4 className="fw-bold text-purple mb-3">Why Choose Madhi Academy for Your Child?</h4>
            <ul className="mb-5 list-unstyled custom-list">
              <li><strong>Experienced Faculty</strong> – Subject experts with proven teaching results</li>
              <li><strong>Small Batch Strength</strong> – More personal attention for every student</li>
              <li><strong>Daily Tuition Support</strong> – Homework guidance & exam preparation</li>
              <li><strong>Study Materials</strong> – Printed & PDF notes for better understanding</li>
              <li><strong>English Communication Training</strong> – Confidence for academics & life</li>
            </ul>

            {/* --- 5. School Tuition Programs --- */}
            <h4 className="fw-bold text-purple mb-4">Our School Tuition Programs</h4>
            
            <div className="mb-4">
              <h5 className="fw-bold text-dark">Primary (1st – 5th Standard)</h5>
              <ul className="custom-list small-text">
                <li>Basics in English, Maths, Science</li>
                <li>Activity-based learning for better understanding</li>
                <li>Support in Tamil & English mediums</li>
              </ul>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold text-dark">Middle School (6th – 8th Standard)</h5>
              <ul className="custom-list small-text">
                <li>Subject-wise tuition: Maths, Science, Social Science, English</li>
                <li>Weekly tests to track performance</li>
                <li>Foundation building for higher classes</li>
              </ul>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold text-dark">High School (9th – 10th Standard)</h5>
              <ul className="custom-list small-text">
                <li>Board exam-oriented preparation (State Board & CBSE)</li>
                <li>Past paper practice & time management training</li>
                <li>Concept clarity + exam writing skills</li>
              </ul>
            </div>

            <div className="mb-5">
              <h5 className="fw-bold text-dark">Higher Secondary (11th – 12th Standard)</h5>
              <ul className="custom-list small-text">
                <li>Special coaching for Commerce, Science & Maths streams</li>
                <li>Competitive exam support (NEET, JEE, CA Foundation, CMA Foundation)</li>
                <li>Career counseling for higher studies</li>
              </ul>
            </div>

            {/* --- 6. Special Features --- */}
            <h4 className="fw-bold text-purple mb-3">Special Features</h4>
            <ul className="mb-5 list-unstyled custom-list">
              <li>Regular Monday–Friday tuition with <strong>doubt-clearing sessions</strong></li>
              <li>Personalised support for weak subjects</li>
              <li>Exam revision camps before finals</li>
              <li>Monthly <strong>progress reports</strong> shared with parents</li>
            </ul>

            {/* --- 7. Testimonials --- */}
            <div className="bg-light p-4 rounded mb-5">
              <h4 className="fw-bold text-purple mb-3">Parent Testimonials</h4>
              <blockquote className="blockquote mb-3">
                <p className="fs-6 fst-italic">"My son’s marks improved from 60% to 85% within a year."</p>
                <footer className="blockquote-footer mt-1">Mrs. Latha</footer>
              </blockquote>
              <blockquote className="blockquote mb-0">
                <p className="fs-6 fst-italic">"Best tuition for CBSE students in Chennai. Teachers are very patient."</p>
                <footer className="blockquote-footer mt-1">Mr. Ramesh</footer>
              </blockquote>
            </div>

            {/* --- 8. FAQs --- */}
            <h4 className="fw-bold text-purple mb-3">FAQs</h4>
            <div className="mb-4">
              <p className="fw-bold mb-1 text-dark">Q: Do you have weekend classes?</p>
              <p className="text-muted">Yes – we conduct extra doubt-clearing & competitive exam sessions.</p>
            </div>
            <div className="mb-5">
              <p className="fw-bold mb-1 text-dark">Q: Do you provide online tuition?</p>
              <p className="text-muted">Yes – we offer recorded lessons + live Q&A sessions for outstation students.</p>
            </div>

            {/* --- 9. Admissions Open (Footer) --- */}
            <div className="border-top pt-4">
              <h4 className="fw-bold text-purple mb-3 text-center">Admissions Open – Enroll Today for Academic Excellence</h4>
              <p className="text-center mb-4">Give your child the right guidance with <strong>Madhi Academy’s school tuition programs.</strong></p>
              
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <ul className="list-unstyled contact-list">
                    <li className="mb-2"><strong>Classes:</strong> 1st to 12th Standard – State Board & CBSE</li>
                    <li className="mb-2"><strong>Location:</strong> Nammalwarpet, Chennai (with online support available)</li>
                    <li className="mb-2">
                      <strong>Contact:</strong>{" "}
                      <a href="tel:+917708941960" className="text-decoration-none text-purple fw-bold">+91 7708941960</a> |{" "}
                      <a href="mailto:admission@madhiacademy.com" className="text-decoration-none text-purple fw-bold">admission@madhiacademy.com</a>
                    </li>
                    <li className="mb-2">
                      <strong>Website:</strong>{" "}
                      <a href="https://school.madhiacademy.com" className="text-decoration-none text-purple fw-bold">school.madhiacademy.com</a>
                    </li>
                  </ul>
                </div>
              </div>
              
              <p className="text-center mt-4 small text-muted">
                If you are looking for the <strong>best tuition centre in Chennai for State Board & CBSE students</strong>, Madhi Academy is your trusted partner for success.
              </p>
            </div>

          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPostDetail;